import * as  React from 'react';
import './index.scss';
import { Space, Input, Avatar, Button, Flex, Typography, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { getData } from '../../../../../actions/apiCall';
import { constants } from '../../../../../constants/common';
const { Search } = Input;

interface FilterProps {
    projectId: string;
    onSearch?: (e: string[]) => void;
}

const Filter: React.FC<FilterProps> = ({ projectId, onSearch }) => {
    const dispatch = useDispatch();
    const [selectedMember, setSelectedMember] = React.useState<string[]>([]);
    const [teams, setTeams] = React.useState([]);

    React.useEffect(() => {
        getTeams()
    }, [projectId]);

    React.useEffect(() => {
        if (onSearch) {
            onSearch(selectedMember);
        }
    }, [selectedMember]);

    const getTeams = async () => {
        const resData = await dispatch(getData(`/teams/${projectId}`));
        if (resData.code == 200) {
            console.log(resData.data);
            setTeams(resData.data);
        }
    }

    const selectMember = (member) => {
        if (selectedMember.includes(member)) {
            setSelectedMember(selectedMember.filter(ele => ele !== member));
            return;
        }

        setSelectedMember([...selectedMember, member]);
    }

    const onClearFilter = () => {
        setSelectedMember([]);
    }

    const getInitials = (user: { firstName: string, lastName: string }) => {
        let name = user.firstName + ' ' + user.lastName;
        return name.split(' ').map(e => e[0]).join('');
    }

    return (
        <Flex justify='space-between'>
            <Space direction='horizontal' style={{ marginBottom: '10px' }}>
                <Search />
                <Avatar.Group>
                    {teams.map(ele => <Tooltip title={constants.GET_FULL_NAME(ele?.teamMember)} > <Avatar style={{
                        cursor: 'pointer',
                        border: selectedMember.find(e => e == ele._id) ? '2px solid blue' : 'none'
                    }} onClick={() => selectMember(ele?._id)}
                        src={`${process.env.FILE_URL}${ele?.teamMember?.avatar}`}
                        onError={() => true}
                    >
                        {getInitials(ele?.teamMember)}
                    </Avatar>
                    </Tooltip>)}
                </Avatar.Group>
                {selectedMember.length > 0 && <Button type={'text'} onClick={onClearFilter}>Clear Filter</Button>}
            </Space>
        </Flex >
    );
};

export default Filter;
